export class DismissableNotice {
	constructor() {
		
		const notices = document.querySelectorAll('.site-notice.dismissable');

		notices?.forEach(notice => {
			notice.querySelector('.close')?.addEventListener('click',e => {
				e.preventDefault();
				notice.classList.add('d-none');
			});
		});
		
		

	}


}